import { useEffect } from 'react'
import mapboxgl from 'mapbox-gl'

interface UseMapResizeProps {
  map: React.MutableRefObject<mapboxgl.Map | null>
  mapLoaded: boolean
  width?: string | number
  height?: string | number
}

/**
 * Hook to handle map resize on window resize and prop changes
 */
export const useMapResize = ({
  map,
  mapLoaded,
  width,
  height,
}: UseMapResizeProps) => {
  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      if (map.current) {
        // Force map to resize
        map.current.resize()
      }
    }

    // Add resize event listener
    window.addEventListener('resize', handleResize)

    // Trigger initial resize
    const timeoutId = setTimeout(() => {
      handleResize()
    }, 100)

    return () => {
      window.removeEventListener('resize', handleResize)
      clearTimeout(timeoutId)
    }
  }, [mapLoaded])

  // Handle width/height prop changes
  useEffect(() => {
    if (map.current && mapLoaded) {
      const timeoutId = setTimeout(() => {
        map.current?.resize()
      }, 100)

      return () => clearTimeout(timeoutId)
    }
  }, [width, height, mapLoaded])
}
